module.exports = __webpack_public_path__ + "img/null@2x.39152913.png";